export default "__VITE_ASSET__b5682ae8__"